var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAdmin = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 14,
  height: 14,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M6.392 1.903c.174-.537.935-.537 1.11 0l.885 2.726c.078.24.302.404.555.404h2.867c.565 0 .8.723.343 1.055l-2.32 1.685a.58.58 0 0 0-.212.652l.886 2.726c.175.538-.44.985-.897.652l-2.32-1.685a.58.58 0 0 0-.685 0l-2.32 1.685c-.457.333-1.072-.114-.897-.652l.886-2.726a.58.58 0 0 0-.212-.652L1.74 6.088c-.457-.332-.222-1.055.343-1.055H4.95a.58.58 0 0 0 .555-.404l.886-2.726z"
})));
export default SvgAdmin;